import { Tab, TabProps } from 'react-admin';

import { LiveLogsPanel } from './LiveLogsPanel';

/**
 * The unit's "Live logs" tab (TVR-2459): nginx, usagelog and eventlog from the metrics cluster.
 * dev_options only, gated where UnitShow renders it.
 *
 * No state here: TabbedShowLayout clones this element twice, as the header and as the content.
 */
export const LiveLogsTab = (props: Omit<TabProps, 'children'>) => (
  <Tab {...props}>
    <LiveLogsPanel />
  </Tab>
);
